import React, {useState, useEffect} from 'react';
import { commerce } from './lib/commerce';
import {Products, Navbar, Cart, Checkout } from './components';
import ScrollHandler from "./components/ScrollHandler";
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

export const App = () => {
  const [categories, setCategories] = useState([]);
  const [cart, setCart] = useState({});
  const [order, setOrder] = useState({});
  const [errorMessage, setErrorMessage] = useState('');

  const fetchProducts = async () => {
    const {data: products} = await commerce.products.list();
    const { data: categoriesData } = await commerce.categories.list();
  
    const productsPerCategory = categoriesData.reduce((acc, category)=>{
      return [
        ...acc,
        {
          ...category,
          productsData: products.filter((product) =>
            product.categories.find((cat) => cat.id === category.id)
          ),
        },
      ];
    }, [])

    setCategories(productsPerCategory);
  }

  const fetchCart =async () => {
    setCart(await commerce.cart.retrieve())
  }

  const handledAddToCart = async (productId, quantity) => {
    const {cart} = await commerce.cart.add(productId, quantity);

    setCart(cart);
  }

  const handleUpdateCartQty = async (productId, quantity) => {
    const {cart} = await commerce.cart.update(productId, { quantity })

    setCart(cart)
  }

  const handleRemoveFromCart = async (productId) => {
    const {cart} = await commerce.cart.remove(productId);

    setCart(cart);
  }

  const handleEmptyCart = async () => {
    const {cart} = await commerce.cart.empty();

    setCart(cart);
  }

  const refreshCart = async () => {
    const newCart = await commerce.cart.refresh();

    setCart(newCart);
  }

  const handleCaptureCheckout = async (checkoutTokenId, newOrder) => {
    try {
      const incomingOrder = await commerce.checkout.capture(checkoutTokenId, newOrder);

      setOrder(incomingOrder);
      refreshCart();
    } catch (error) {
      setErrorMessage(error.data.error.message);
    }
  }

  useEffect(() => {
    fetchProducts();
    fetchCart();
  }, []);

  return (
    <Router>
      <div>
        <ScrollHandler />
        <Navbar categories={categories} totalItems={cart.total_items} />
        <Switch>
          <Route exact path="/">
            <Products categories={categories} onAddToCart={handledAddToCart} />
          </Route>
          <Route exact path="/cart">
            <Cart cart={cart} handleUpdateCartQty={handleUpdateCartQty} handleRemoveFromCart={handleRemoveFromCart} handleEmptyCar={handleEmptyCart} />
          </Route>
          <Route exac path="/checkout">
            <Checkout cart={cart} order={order} onCaptureCheckout={handleCaptureCheckout} error={errorMessage} />
          </Route>
        </Switch>
      </div>
    </Router>
  );
}

export default App;